module.exports = __webpack_public_path__ + "d00d4b19beb53383e3bff7d80528777d.png";